export interface IMedicalPatientDTO {
  patientId?: number
  patientFirstName?: string
  patientLastName?: string
  gender?: string
  patientPhoneC?: string
  patientEmail?: string
  patientPhoneH?: string
  patientPhoneW?: string
  dob?: Date
  patientAddress?: string
  patientCity?: string
  patientState?: string
  patientZip?: string
  notes?: string
}

export class MedicalPatientDTO implements IMedicalPatientDTO {
  public patientId?: number
  public patientFirstName?: string
  public patientLastName?: string
  public gender?: string
  public patientPhoneC?: string
  public patientEmail?: string
  public patientPhoneH?: string
  public patientPhoneW?: string
  public dob?: Date
  public patientAddress?: string
  public patientCity?: string
  public patientState?: string
  public patientZip?: string
  public notes?: string
}
